import React, { useEffect, useState } from "react";
import {
  deleteBrandApi,
  deleteModelApi,
  getBrandApi,
  getBrandExportApi,
  getModelApi,
  getModelExportApi,
} from "../../../services/VehicleService";
import { Spinner } from "react-bootstrap";
import { CancelRequest } from "../../../services/AxiosInstance";
import Pagination from "../../Constant/Pagination";
import DebounceSmallSearchInput from "../../Constant/DebounceSmallSearchInput";
import { MdAdd } from "react-icons/md";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import AddModelModal from "./AddModelModal";
import AddBrandModal from "./AddBrandModal";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { FiInfo } from "react-icons/fi";
import { CustomTooltip } from "../../../components/CustomTooltip";
import { MultiActionDropdown } from "../../../components";
import { CiImport } from "react-icons/ci";
import { BiExport } from "react-icons/bi";
import ModelImportModal from "./ModelImportModal";
import BrandImportModal from "./BrandImportModal";
const VehicleBrandModel = () => {
  const [brand, setBrand] = useState([]);
  const [brandTotal, setBrandTotal] = useState(0);
  const [brandLoading, setBrandLoading] = useState(false);
  const [barndError, setbrandError] = useState("");
  const [brandModal, setBrandModal] = useState(false);
  const [selectedBrand, setSelecetdBrand] = useState(null);
  const [brandDelete, setBrandDelete] = useState(false);
  const [brandDeleteLoading, setBrandDeleteLoading] = useState(false);
  const [brandExportLoading, setBrandExportLoading] = useState(false);
  const [brandImportOpen, setBrandImportOpen] = useState(false);
  const [brandParam, setBrandParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const [model, setModel] = useState([]);
  const [modelTotal, setModelTotal] = useState(0);
  const [modelLoading, setModelLoading] = useState(false);
  const [modelError, setModelError] = useState("");
  const [modelModal, setModelModal] = useState(false);
  const [selectedModel, setSelectedModel] = useState(null);
  const [modelDelete, setModelDelete] = useState(false);
  const [modelDeleteLoading, setModelDeleteLoading] = useState(false);
  const [modelExportLoading, setModelExportLoading] = useState(false);
  const [modelImportOpen, setModelImportOpen] = useState(false);
  const [modelParam, setModelParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const getBrand = () => {
    setBrandLoading(true);
    getBrandApi(brandParam)
      .then((res) => {
        setbrandError("");
        setBrand(res?.data?.results || []);
        setBrandTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setbrandError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setBrandLoading(false);
      });
  };

  const getModel = () => {
    setModelLoading(true);
    getModelApi(modelParam)
      .then((res) => {
        setModelError("");
        setModel(res?.data?.results || []);
        setModelTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setModelError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setModelLoading(false);
      });
  };

  useEffect(() => {
    getBrand();
  }, [brandParam]);

  useEffect(() => {
    getModel();
  }, [modelParam]);

  const handleToggleModelImport = () => {
    setModelImportOpen(!modelImportOpen);
  };

  const handleToggleBrandImport = () => {
    setBrandImportOpen(!brandImportOpen);
  };

const handleToggleBrandModal = () => {
  if (brandModal) {
    setSelecetdBrand(null);
  }
  setBrandModal(!brandModal);
};

const handleToggleModelModal = () => {
  if (modelModal) {
    setSelectedModel(null);
  }
  setModelModal(!modelModal);
};

const handleAfterBrandModal = () => {
  handleToggleBrandModal();
  getBrand();
};

const handleAfterModelModal = () => {
  handleToggleModelModal();
  getModel();
};

const handleToggleBrandDelete = () => {
  if (brandDelete) {
    setSelecetdBrand(null);
  }
  setBrandDelete(!brandDelete);
};

const handleToggleModelDelete = () => {
  if (modelDelete) {
    setSelectedModel(null);
  }
  setModelDelete(!modelDelete);
};

const handleDeleteBrand = () => {
  setBrandDeleteLoading(true);
  deleteBrandApi(selectedBrand?.id)
    .then((res) => {
      toast.success("Delete Successfully");
      getBrand();
      handleToggleBrandDelete();
    })
    .catch((err) => {
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try again later"
      );
    })
    .finally(() => {
      setBrandDeleteLoading(false);
    });
};

const handleDeleteModel = () => {
  setModelDeleteLoading(true);
  deleteModelApi(selectedModel?.id)
    .then((res) => {
      toast.success("Delete Successfully");
      getModel();
      handleToggleModelDelete();
    })
    .catch((err) => {
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try again later"
      );
    })
    .finally(() => {
      setModelDeleteLoading(false);
    });
};

const handleModelPageChange = (page) => {
  setModelParam((prev) => ({
    ...prev,
    page: page.selected + 1,
  }));
};

const handleModelSearchChange = (value) => {
  if (value.length > 0) CancelRequest();
  setModelParam((prev) => ({
    ...prev,
    query: value,
    page: 1,
  }));
};

const handleBrandPageChange = (page) => {
  setBrandParam((prev) => ({
    ...prev,
    page: page.selected + 1,
  }));
};

const handleBrandSearchChange = (value) => {
  if (value.length > 0) CancelRequest();
  setBrandParam((prev) => ({
    ...prev,
    query: value,
    page: 1,
  }));
};
const handelModelExport = () => {
  setModelExportLoading(true);
  getModelExportApi({ ...modelParam, export: true })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Model.xlsx";

      // Append to DOM to make it more consistent
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try again later"
      );
    })
    .finally(() => {
      setModelExportLoading(false);
    });
};
const handelBrandExport = () => {
  setBrandExportLoading(true);
  getBrandExportApi({ ...brandParam, export: true })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Brand.xlsx";

      // Append to DOM to make it more consistent
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try again later"
      );
    })
    .finally(() => {
      setBrandExportLoading(false);
    });
};

const handleAfterModelImport = () => {
  handleToggleModelImport();
  getModel();
};
const handleAfterBrandImport = () => {
  handleToggleBrandImport();
  getBrand();
}


  return (
    <div className="container-fluid p-0">
      <div className="row g-2">
        <div className="col-md-6">
          <div className="card">
            <div className="p-3 d-flex justify-content-between gap-2 flex-wrap">
              <h4 className="text-primary align-self-center">Brand</h4>
              <div className="d-flex gap-1">
                <div>
                  <DebounceSmallSearchInput
                    handleSearchChange={handleBrandSearchChange}
                  />
                </div>
                {/* <CustomTooltip title="Add Brand">
                  <button
                    className="btn stylish-transparent-btn"
                    onClick={handleToggleBrandModal}
                    style={{ padding: "0.5rem" }}
                  >
                    <MdAdd size="22" />
                  </button>
                </CustomTooltip> */}
                <MultiActionDropdown
                  variant="outline-secondary"
                  btnIcon={brandExportLoading?<Spinner animation="border" size="sm"/>:<MdAdd size={19} />}
                  btnOnClick={handleToggleBrandModal}
                  onlyIcon
                  menuOptions={[
                    {
                      label: "Import",
                      icon: <CiImport />,
                      onClick: handleToggleBrandImport,
                    },
                    {
                      label: "Export",
                      icon: <BiExport />,
                      onClick: handelBrandExport,
                    },
                  ]}
                />
              </div>
            </div>
            <div>
              {brandLoading ? (
                <div className="text-center my-4">
                  <Spinner animation="border" />
                </div>
              ) : barndError ? (
                <div className="text-center my-4 text-danger">{barndError}</div>
              ) : brand && brand?.length > 0 ? (
                <div className="table-responsive">
                  <table className="table fs-6 mb-0 align-middle">
                    <thead className="table-light custom-thead">
                      <tr>
                        <th>Brand Name</th>
                        <th>Vehicle Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {brand?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{item?.name || "-"}</td>
                          <td>{item?.is_bike ? "Bike" : "Car"}</td>
                          <td>
                            <div className="d-flex gap-1 align-self-start">
                              <span
                                className="p-1 btn btn-outline-light ms-1"
                                onClick={() => {
                                  setSelecetdBrand(item);
                                  handleToggleBrandModal();
                                }}
                              >
                                <FiEdit2 className="text-dark" size="12" />
                              </span>
                              <span
                                className="p-1 btn btn-outline-light ms-1"
                                onClick={() => {
                                  setSelecetdBrand(item);
                                  handleToggleBrandDelete();
                                }}
                              >
                                <FiTrash2 className="text-dark" size="12" />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center my-4">No data found</div>
              )}
              {!brandLoading && brand?.length > 0 && (
                <div className="p-4">
                  <Pagination
                    currentPage={brandParam.page}
                    recordsPage={brandParam.page_size}
                    dataLength={brandTotal}
                    handlePagination={handleBrandPageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="p-3 d-flex justify-content-between gap-2 flex-wrap">
              <div className="d-flex gap-1 align-items-center">
                {/* <span
                  className="btn btn-outline-light rounded-2"
                  style={{ padding: "0.5rem" }}
                >
                  <FaArrowLeft className="text-dark" />
                </span> */}
                <h4 className="text-primary align-self-center">Model</h4>
              </div>
              <div className="d-flex gap-1">
                <div>
                  <DebounceSmallSearchInput
                    handleSearchChange={handleModelSearchChange}
                  />
                </div>
                {/* <CustomTooltip title="Add Model">
                  <button
                    className="btn stylish-transparent-btn"
                    onClick={handleToggleModelModal}
                    style={{ padding: "0.5rem" }}
                  >
                    <MdAdd size="22" />
                  </button>
                </CustomTooltip> */}
                <MultiActionDropdown
                  variant="outline-secondary"
                  btnIcon={modelExportLoading?<Spinner animation="border" size="sm"/>:<MdAdd size={19} />}
                  btnOnClick={handleToggleModelModal}
                  onlyIcon
                  menuOptions={[
                    {
                      label: "Import",
                      icon: <CiImport />,
                      onClick: handleToggleModelImport,
                    },
                    {
                      label: "Export",
                      icon: <BiExport />,
                      onClick: handelModelExport,
                    },
                  ]}
                />
              </div>
            </div>
            <div>
              {modelLoading ? (
                <div className="text-center my-4">
                  <Spinner animation="border" />
                </div>
              ) : modelError ? (
                <div className="text-center my-4 text-danger">{modelError}</div>
              ) : model && model?.length > 0 ? (
                <div className="table-responsive">
                  <table className="table fs-6 mb-0 align-middle">
                    <thead className="table-light custom-thead">
                      <tr>
                        <th>Model Name</th>
                        <th>Brand</th>
                        <th>Model Type</th>
                        <th>Model Size</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {model?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{item?.name || "-"}</td>
                          <td>{item?.brand_name || "-"}</td>
                          <td>{item?.model_type || "-"}</td>
                          <td>{item?.model_size || "-"}</td>
                          <td>
                            <div className="d-flex gap-1 align-self-start">
                              <span
                                className="p-1 btn btn-outline-light ms-1"
                                onClick={() => {
                                  setSelectedModel(item);
                                  handleToggleModelModal();
                                }}
                              >
                                <FiEdit2 className="text-dark" size="12" />
                              </span>
                              <span
                                className="p-1 btn btn-outline-light ms-1"
                                onClick={() => {
                                  setSelectedModel(item);
                                  handleToggleModelDelete();
                                }}
                              >
                                <FiTrash2 className="text-dark" size="12" />
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center my-4">No data found</div>
              )}
              {!modelLoading && model?.length > 0 && (
                <div className="p-4">
                  <Pagination
                    currentPage={modelParam.page}
                    recordsPage={modelParam.page_size}
                    dataLength={modelTotal}
                    handlePagination={handleModelPageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <AddModelModal
        data={selectedModel}
        visible={modelModal}
        onClose={handleToggleModelModal}
        onAfterSubmit={handleAfterModelModal}
      />

      <AddBrandModal
        data={selectedBrand}
        visible={brandModal}
        onClose={handleToggleBrandModal}
        onAfterSubmit={handleAfterBrandModal}
      />
      <ModelImportModal
        visible={modelImportOpen}
        onClose={handleToggleModelImport}
        afterSubmit={handleAfterModelImport}
      />
      <BrandImportModal
        visible={brandImportOpen}
        onClose={handleToggleBrandImport}
        afterSubmit={handleAfterBrandImport}
      />

      <Dialog
        maxWidth="xs"
        fullWidth
        open={brandDelete}
        onClose={handleToggleBrandDelete}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>{selectedBrand?.name}</strong>?
              This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleBrandDelete}
            color="inherit"
            disabled={brandDeleteLoading}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={handleDeleteBrand}>
            {brandDeleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        maxWidth="xs"
        fullWidth
        open={modelDelete}
        onClose={handleToggleModelDelete}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>{selectedModel?.name}</strong>?
              This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleModelDelete}
            color="inherit"
            disabled={modelDeleteLoading}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={handleDeleteModel}>
            {modelDeleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VehicleBrandModel;
